import { showNotification } from 'modules/notifications';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useNotificationAndRedirect = () => {
  const navigate = useNavigate();

  return useCallback(
    (message: string, path: string) => {
      navigate(path);

      showNotification({
        message,
        variant: 'success',
        autoHideDuration: 3_000,
      });
    },
    [navigate],
  );
};
